const urlHelper = {
  getPaymentdetails(payload: any) {
    return `/rest/consigner/v2/web/balance/trip?code=${payload.code}`;
  },
  getDocument(payload: any) {
    return `/rest/consigner/v2/web/demand/${payload.code}/document?document-code=${payload.DocumentCode}`;
  },
  initiatePayment() {
    return `/rest/consigner/v1/web/pay/create-order`;
  },
  initiatePaymentStatus(payload: any) {
    return `/rest/consigner/v1/web/pay/complete-order`;
  },
};

export default urlHelper;
